// Fade duration (ms) for SplashScreen.hide() — a short cross-fade from the held native splash to
// the mounted React app, so the handoff reads as one continuous screen rather than a hard cut.
export const SPLASH_FADE_OUT_MS = 200;

// Id of the WebView boot splash markup in public/index.html. On native it is suppressed so the
// HELD native splash is the only boot screen (no second, mismatched flash during the WebView load).
export const WEB_SPLASH_ELEMENT_ID = 'splash-screen';

// Failsafe ceiling (ms). The native splash is HELD (launchAutoHide:false), so if the boot chain
// throws or its promise never settles, hideNativeSplash() would never run and the splash would
// stay up forever. armNativeSplashFailsafe() force-hides after this ceiling as a last resort.
export const SPLASH_FAILSAFE_MS = 10000;
